/**
 * Client main entry
 */

require('./src/Client');
